import React from 'react';
import { motion } from 'framer-motion';

const reasons = [
  {
    title: 'Peer-Reviewed Excellence',
    description:
      'IMPACT ensures all submissions undergo a thorough peer-review process, maintaining high scientific standards and credibility.',
    className: 'wcu-peer-reviewed',
  },
  {
    title: 'Wide Reach & Visibility',
    description:
      'Articles published in IMPACT gain global visibility through indexed databases and academic sharing platforms.',
    className: 'wcu-wide-reach',
  },
  {
    title: 'Rapid Publication Process',
    description:
      'We value your time. IMPACT follows an efficient editorial workflow to reduce turnaround times without compromising quality.',
    className: 'wcu-rapid-publication',
  },
  {
    title: 'Open Access Model',
    description:
      'Our open access policy enables your work to be freely accessible, increasing readership and citation potential.',
    className: 'wcu-open-access',
  },
  {
    title: 'Supportive Editorial Team',
    description:
      'Our expert editors provide guidance at every step to make the publishing journey smooth and author-friendly.',
    className: 'wcu-editorial-support',
  },
  {
    title: 'Diverse Research Scope',
    description:
      'IMPACT welcomes interdisciplinary and innovative research, fostering a broad spectrum of medical and scientific exploration.',
    className: 'wcu-diverse-scope',
  },
];


const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const WhyChoosePromed = () => {
  return (
    <motion.section
      className="wcu-section-pm"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={containerVariants}
    >
      <motion.h2 className="wcu-title-pm" variants={itemVariants}>
        Why choose us for publishing
      </motion.h2>
      <motion.div className="wcu-grid-pm" variants={containerVariants}>
        {reasons.map((item, index) => (
          <motion.div
            className={`wcu-card-pm ${item.className}`}
            key={index}
            variants={itemVariants}
          >
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
};

export default WhyChoosePromed;